import {
	Accordion,
	AccordionSummary,
	Grid,
	Paper,
	Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { useSelector } from "react-redux";

import { mapDictionaryOptions } from "../../utils/functions";

const useStyles = makeStyles((theme) => ({
	"@global": {
		"#enhanced-card": {
			padding: "8px 16px 16px",
		},
	},
	root: {
		backgroundColor: theme.accordion.background,
		borderTopRightRadius: "5px",
		borderTopLeftRadius: "5px",
		borderBottomRightRadius: "5px",
		borderBottomLeftRadius: "5px",
		minHeight: "38px !important",
		cursor: "text !important",
		"& .MuiAccordionSummary-content": {
			padding: "16px 16px 0px !important",
		},
		"&.MuiAccordionSummary-root": {
			minHeight: "38px",
			maxHeight: "55px",
			backgroundColor:
				theme.palette.mode === "dark" ? "#3C4E5F" : "#D1E4F6",
		},
	},
	elevation1: {
		boxShadow: "none",
	},
	keyValue: {
		WebkitLineClamp: 4,
		overflow: "hidden",
		textOverflow: "ellipsis",
		maxHeight: "6.2em",
		whiteSpace: "normal",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		wordBreak: "break-all",

		"& .title": {
			display: "block",
			fontWeight: "bold",
			fontSize: "13px",
		},
	},
}));

const EnhancedCard = (props) => {
	const { row } = props;

	const classes = useStyles();
	const dictionary = useSelector((state) => state.dictionary.dictionary);
	const stateOptions = mapDictionaryOptions(dictionary.codeStates);

	// Get State Label
	const getStateLabel = (rState) => {
		const state = stateOptions.find((s) => s.value === rState);
		return state?.label || "-";
	};

	return (
		<div>
			<Paper classes={{ elevation1: classes.elevation1 }}>
				<div>
					<Accordion style={{ minWidth: "1450px" }}>
						<AccordionSummary
							id="enhanced-card"
							className={classes.root}
						>
							<Grid
								container
								spacing={1.5}
								sx={{
									display: "flex !important",
									alignItems: "center !important",
								}}
							>
								<Grid sm={1.5}>
									<Typography
										className={classes.keyValue}
										variant="subtitle2"
										title={row?.phoneNo || undefined}
									>
										<span className="title">
											Phone Number
										</span>
										{row?.phoneNo || "-"}
									</Typography>
								</Grid>
								<Grid sm={1.5}>
									<Typography
										className={classes.keyValue}
										variant="subtitle2"
										title={row?.cellNo || undefined}
									>
										<span className="title">
											Cell Phone
										</span>
										{row?.cellNo || "-"}
									</Typography>
								</Grid>
								<Grid sm={2}>
									<Typography
										className={classes.keyValue}
										variant="subtitle2"
										title={row?.address || undefined}
									>
										<span className="title">
											Residential Address
										</span>
										{row?.address || "-"}
									</Typography>
								</Grid>
								<Grid sm={1.5}>
									<Typography
										className={classes.keyValue}
										variant="subtitle2"
										title="Residential City"
									>
										<span className="title">
											Residential City
										</span>
										{row?.rCity ? row?.rCity : "-"}
									</Typography>
								</Grid>
								<Grid sm={1.5}>
									<Typography
										className={classes.keyValue}
										variant="subtitle2"
										title={
											row?.rState
												? getStateLabel(
														row?.rState,
														row?.employeeNum
												  )
												: undefined
										}
									>
										<span className="title">
											Residential State
										</span>
										{row?.rState
											? getStateLabel(
													row?.rState,
													row?.employeeNum
											  )
											: "-"}
									</Typography>
								</Grid>
								<Grid sm={1}>
									<Typography
										className={classes.keyValue}
										variant="subtitle2"
										title={row?.rZip || undefined}
									>
										<span className="title">
											Residential Zip
										</span>
										{row?.rZip || "-"}
									</Typography>
								</Grid>
								<Grid sm={1.5}>
									<Typography
										className={classes.keyValue}
										variant="subtitle2"
										title={
											row?.dob
												? moment(row?.dob).format(
														"MM/DD/YYYY"
												  )
												: undefined
										}
									>
										<span className="title">DOB</span>
										{row?.dob
											? moment(row?.dob).format(
													"MM/DD/YYYY"
											  )
											: "-"}
									</Typography>
								</Grid>
								<Grid sm={1.5}>
									<Typography
										variant="subtitle2"
										className={classes.keyValue}
										title={
											row?.hireDate
												? moment(row.hireDate).format(
														"MM/DD/YYYY"
												  )
												: undefined
										}
									>
										<span className="title">Hire Date</span>
										{row?.hireDate
											? moment(row.hireDate).format(
													"MM/DD/YYYY"
											  )
											: "-"}
									</Typography>
								</Grid>
							</Grid>
						</AccordionSummary>
					</Accordion>
				</div>
			</Paper>
		</div>
	);
};

export default EnhancedCard;
